"use strict";
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUtils = void 0;
const enums_1 = require("../common/enums");
/**
 * Utility methods to generate file names on workdocs documents
 */
class FileUtils {
    /**
     * Organisation settings folder path
     * @param organisationId - Id of the organisation
     * @param type - FileUploadType
     * @returns - Folder path of document
     */
    static generateSettingsFolderPath(organisationId, type) {
        return `${enums_1.DynamoModelType.ORG}#${organisationId}-${FileUtils.SETTINGS_SLUG}-${enums_1.DynamoModelType.DATA_UPLOAD_TYPE}#${type}`;
    }
    /**
     * Projects folder path
     * @param organisationId - Id of the organisation
     * @param projectId - Id of the project
     * @returns - Folder path of document
     */
    static generateProjectsFolderPath(organisationId, projectId) {
        return `${enums_1.DynamoModelType.ORG}#${organisationId}-${enums_1.DynamoModelType.PROJECT}#${projectId}`;
    }
    /**
     * Projects folder path
     * @param organisationId - Id of the organisation
     * @param projectId - Id of the project
     * @param taskId - Id of the task
     * @returns - Folder path of document
     */
    static generateProjectTasksFolderPath(organisationId, projectId, taskId) {
        return `${enums_1.DynamoModelType.ORG}#${organisationId}-${enums_1.DynamoModelType.PROJECT}#${projectId}-${enums_1.DynamoModelType.TASK}#${taskId}`;
    }
    /**
     * Awards folder path
     * @param organisationId - Id of the organisation
     * @param opportunityId - Id of the opportunity
     * @param opportunityLotId - Id of the opportunity lot
     * @returns - Folder path of document
     */
    static generateAwardsFolderPath(organisationId, opportunityId, opportunityLotId) {
        return `${enums_1.DynamoModelType.ORG}#${organisationId}-${enums_1.DynamoModelType.OPPORTUNITY}#${opportunityId}-${enums_1.DynamoModelType.OPPORTUNITY_LOT_ID}#${opportunityLotId}`;
    }
    /**
     * Generates the file name
     * @param rawFolderPath - Folder path to create the file
     * @param cleanedFileName - Name of the file
     * @returns - Name of document to be uploaded
     */
    static generateRawFileName(rawFolderPath, cleanedFileName) {
        return `${rawFolderPath}-${cleanedFileName}`;
    }
    /**
     * Organisation Profile folder path
     * @param organisationId - Id of the organisation
     * @returns - Folder path of document
     */
    static generateOrganisationProfileFolderPath(organisationId) {
        return `${enums_1.DynamoModelType.ORG}#${organisationId}-${FileUtils.ORGANISATION_PROFILE}`;
    }
}
exports.FileUtils = FileUtils;
FileUtils.SETTINGS_SLUG = 'SETTINGS';
FileUtils.ORGANISATION_PROFILE = 'ORGANISATION_PROFILE';
/**
 * Bucket name for MessageAttachments
 * @param stage - Process environment
 * @param stack - Aws stack name
 * @returns - Folder path of document
 */
FileUtils.getMessageBucketName = (stage, stack) => {
    const bucketName = `${stage}-${stack}-message-attachments`;
    return bucketName;
};
/**
 * Bucket name for Document Centre attachments
 * @param stage - Process environment
 * @param stack - Aws stack name
 * @returns - Folder path of document
 */
FileUtils.getDocumentCentreBucketName = (stage, stack) => {
    const stageName = stage || process.env.STAGE || 'dev';
    const stackName = stack || process.env.STACK_NAME || 'fox';
    return `${stageName}-${stackName}-organisation-documents`;
};
/**
 * File Path for MessageAttachments
 * @param orgSlug - Slug of Organisation
 * @param UserId - Id of User
 * @param threadId - Id of message thread
 * @param messageId - Id of message
 * @param fileName - Name of the file
 * @returns - Folder path of document
 */
FileUtils.getFilePathForMessageAttachment = (orgSlug, userId, threadId, messageId, fileName) => {
    const constructedFileName = `${orgSlug}/${userId}/${threadId}/${messageId}/${fileName}`;
    return constructedFileName;
};
//# sourceMappingURL=data:application/json;base64,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